import type {
  AudienceSelectionRef,
  QuestionnaireDraftReadiness,
  SurveyJson,
} from "@digital-twins/shared-types";
import i18n from "@/i18n";
import { formatIssueCopy } from "@/features/studies/questionnaire/utils/questionnaireIssueCopy";

/**
 * A compile of the persisted draft, as Review's one entry (`enterReview`)
 * reads it: the survey and revision Review pins, that revision's audience,
 * and the backend's verdict, which is the only advance authority.
 */
export interface ReviewCompile {
  surveyJson: SurveyJson | null;
  revision: number | null;
  readiness: QuestionnaireDraftReadiness | null;
  audience: AudienceSelectionRef | null;
  /** The draft's title, which seeds an empty study-name field. */
  title?: string | null;
}

/**
 * Why Review stays shut on this compile, as the line the user reads; null
 * when it opens. The fresh backend verdict is the only advance authority,
 * checked before the survey: a draft the backend blocks legitimately has
 * none, and its blocking issue is what the user needs to hear.
 */
export function reviewEntryRefusal(
  entry: ReviewCompile,
  draftId: string,
): string | null {
  const readiness = entry.readiness;
  if (!readiness?.isReviewEligible) {
    const firstIssue = readiness?.blockingIssues?.[0];
    return firstIssue
      ? formatIssueCopy(firstIssue, {
          resolvedMinimum: readiness?.resolvedMinimum,
          draftId,
        }).text
      : i18n.t("questionnaire.reviewRetry", { ns: "app" });
  }
  if (!entry.surveyJson || entry.revision === null) {
    return i18n.t("questionnaire.reviewRetry", { ns: "app" });
  }
  return null;
}
